export const PROJECT_PREFIX = 'flex';

export const MIXPANEL_EVENTS = {
  BUTTON_CLICK: 'button-click',
  EMAIL_SUPPORT_LINK: 'email-support-link',
  PAGE_VIEW: 'page-view',
  ASSESSMENT_ANSWER: 'assessment-answer',
  ASSESSMENT_BACK_BUTTON: 'assessment-back-button',
  RESULTS: 'results',
  ASSOCIATE_EMAIL: 'associate-email',
  REGISTRATION_COMPLETE: 'registration-complete',
  FAILED_SMS_COMPLETE_REG: 'failed-sms-complete-reg',
  SUCCESSFUL_SMS_COMPLETE_REG: 'successful-sms-complete-reg',
  EXIT_INTENT_SHOWING: 'exit-intent-showing',
  EXIT_INTENT_CLOSED: 'exit-intent-closed',
  EXIT_INTENT_REASON: 'exit-intent-reason',
};
